const PREFIX = 'FACILITY_SHIFT_USERS_'
export const FACILITY_SHIFT_USERS = {
  FETCH_REQUEST: `${PREFIX}FETCH_REQUEST`,
  FETCH_SUCCESS: `${PREFIX}FETCH_SUCCESS`,
  FETCH_FAILURE: `${PREFIX}FETCH_FAILURE`
}
